import { PropsWithChildren } from "react";

import { css } from "@compiled/react";

import { JiraLogo, JiraServiceManagementLogo } from "@atlaskit/logo";
import { media } from "@atlaskit/primitives";

import { wacToken } from "@/libraries/design/foundations";

import { useSearchParameters } from "../../hooks";
import { ProductKey } from "../../models";

type JiraOnboardingContainerProps = {
    header: string;
    subheader: string;
    hideSubHeader?: boolean;
    hideFooterOnMobile?: boolean;
    PreHeader?: () => JSX.Element;
};

const list = css({
    [media.below.sm]: {
        marginBlockEnd: "50px"
    }
});

const elevate = css({
    paddingBlockStart: "40px",
    gap: "28px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
});

const container = css({
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "32px",
    padding: "0 18px 40px 18px"
});
const headerContainer = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "4px",
    textAlign: "center",
    padding: "0 40px"
});
const headerFont = css({
    fontWeight: "700",
    lineHeight: "48px",
    fontSize: "40px",
    fontFamily: wacToken("font.charlie.display"),
    margin: "0px",
    [media.below.md]: {
        lineHeight: "38px",
        fontSize: "32px"
    }
});
const subheaderFont = css({
    color: wacToken("color.primary.black"),
    lineHeight: "24px",
    fontWeight: "400",
    fontSize: "16px",
    fontFamily: wacToken("font.charlie.display"),
    margin: "0px",
    textAlign: "center",
    [media.below.md]: {
        lineHeight: "20px",
        fontSize: "14px"
    }
});

const maxHeightContainer = css({
    color: wacToken("color.primary.black"),
    margin: "auto",
    fontFamily: wacToken("font.charlie.display"),
    textAlign: "center",
    display: "grid",
    gridTemplateRows: "auto",
    height: "100vh"
});

const JiraHeader = ({
    header,
    subheader,
    hideSubHeader = false,
    PreHeader
}: {
    header: string;
    subheader: string;
    hideSubHeader?: boolean; // go with experiment jsw_transparent_software_jtbd
    PreHeader?: () => JSX.Element;
}) => {
    const searchParameters = useSearchParameters();
    const { products = [] } = searchParameters;

    const isJsm = products.includes(ProductKey.JIRA_SERVICE_MANAGEMENT);

    return (
        <div css={elevate}>
            {isJsm ? (
                <JiraServiceManagementLogo appearance="brand" />
            ) : (
                <JiraLogo size="xlarge" appearance="brand" />
            )}
            <div css={headerContainer}>
                {PreHeader && <PreHeader />}
                <h1 css={headerFont}>{header}</h1>
                {!hideSubHeader && <h2 css={subheaderFont}>{subheader}</h2>}
            </div>
        </div>
    );
};

export const JiraOnboardingContainer = ({
    header,
    subheader,
    hideSubHeader, // go with experiment jsw_transparent_software_jtbd
    PreHeader,
    children
}: JiraOnboardingContainerProps & PropsWithChildren) => {
    return (
        <div css={maxHeightContainer}>
            <div css={container}>
                <JiraHeader
                    header={header}
                    subheader={subheader}
                    hideSubHeader={hideSubHeader}
                    PreHeader={PreHeader}
                />
                <div css={list}>{children}</div>
            </div>
        </div>
    );
};
